<div class="masquerade-handler-container">
  <div class="loading-spinner">
    <vng-spinner diameter="50"></vng-spinner>
    <p class="loading-text">Setting up masquerade session...</p>
    <p class="loading-subtext">Please wait while we load the user's view</p>
  </div>
</div>
